import { brokerFac } from '../../main';
import { getIndicesList } from "./marketDepthPopupApi";
let niftyIndiceList = [];
let bankIndiceList = [];
export function openOrderDialog(Symbol, isBuy, Type, LimitPrice) {
    window.tvWidget.activeChart().setSymbol(Symbol);
    const prodType = localStorage.getItem("productVal");
    const type = localStorage.getItem("defaultClose");
    const host = brokerFac._handleMessageEvent;
    const marketDepthModal = document.getElementById('marketDepthModal');
    const orderData = {
        symbol: Symbol,
        side: isBuy ? 1 : -1,
        type: Type !== undefined ? Type : (type === "Limit" ? 1 : 2),
        customFields: {
            id: prodType || "Delivery",
        },
    };
    LimitPrice !== undefined ? orderData.limitPrice = LimitPrice : null;
    (host === null || host === void 0 ? void 0 : host.showOrderDialog) ? host.showOrderDialog(orderData) : null;
    marketDepthModal.close();
}
const isNumeric = (str) => {
    return (!isNaN(Number(str)) &&
        !isNaN(parseFloat(str)));
};
function intComma(val, maxDecimal = 2, minDecimal = 2) {
    try {
        if (isNumeric("" + val)) {
            let num_val = Math.round(Number(val) * 10 ** minDecimal) / 10 ** minDecimal;
            num_val = num_val === 0 ? 0 : num_val;
            if (minDecimal > maxDecimal) {
                minDecimal = maxDecimal;
            }
            const value = num_val.toLocaleString("en-IN", {
                minimumFractionDigits: minDecimal,
                maximumFractionDigits: maxDecimal,
            });
            return value;
        }
        else
            return "-";
    }
    catch (err) {
        console.log(err);
        return "-";
    }
}
// Convert large numbers to lakhs/crores with sign
const convertNumberIntoLakhsAndCroreWithSign = (data, comp) => {
    if (data == undefined) {
        return "-";
    }
    const newData = Math.abs(data);
    let returnValue = "";
    if (newData >= 10000000) {
        returnValue =
            (data / 10000000).toFixed(2) + `${comp === "MyStocks" ? "Cr" : "Cr"}`;
    }
    else if (newData >= 100000) {
        returnValue =
            (data / 100000).toFixed(2) + `${comp === "MyStocks" ? "L" : "L"}`;
    }
    else if (newData >= 1000) {
        returnValue =
            (data / 1000).toFixed(2) + `${comp === "MyStocks" ? "K" : "K"}`;
    }
    else {
        returnValue = intComma(data, 2, 2);
    }
    return returnValue;
};
const convertDateFormat = (dateStr, format) => {
    if (format) {
        return moment(dateStr, format).format("DD MMM'YY");
    }
    return moment(dateStr, "MMM DD YYYY hh:mmA").format("DD MMM'YY");
};
// Format exposure values as multipliers
function formatExposure(value) {
    return `${Math.round(1 / Number(value))}x`;
}
// Format percentage values
function formatPercentage(value) {
    if (value === null || value === undefined || value === 'N.A')
        return 'N/A';
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num))
        return 'N/A';
    return `${num.toFixed(2)} %`;
}
export function populateStockData(apiData, stockType, additionalData) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const returnsData = (additionalData === null || additionalData === void 0 ? void 0 : additionalData.returnsData) || {};
    const rolloverData = (additionalData === null || additionalData === void 0 ? void 0 : additionalData.rolloverData) || {};
    const specialValues = {
        '1M_Ret': ((_a = returnsData['1M_Ret']) !== null && _a !== void 0 ? _a : '-'),
        '3M_Ret': ((_b = returnsData['3M_Ret']) !== null && _b !== void 0 ? _b : '-'),
        '1Y_Ret': ((_c = returnsData['1Y_Ret']) !== null && _c !== void 0 ? _c : '-'),
        'Rollover': ((_d = rolloverData['Rollover']) !== null && _d !== void 0 ? _d : '-'),
        'RollCost': ((_f = (_e = rolloverData['RollCost']) !== null && _e !== void 0 ? _e : rolloverData['RolloverCost']) !== null && _f !== void 0 ? _f : '-'),
    };
    const stockTypeConfig = {
        index: {
            fields: [
                'Open', 'High', 'Low', '1M Ret', '3M Ret', '1Y Ret',
                'PClose', 'Future Price',
            ],
            mappings: {
                'Open': 'OpenRate',
                'High': 'High',
                'Low': 'Low',
                'PClose': 'PClose',
                'Future Price': 'FutPrice',
                '1M Ret': { special: '1M_Ret' },
                '3M Ret': { special: '3M_Ret' },
                '1Y Ret': { special: '1Y_Ret' },
            },
        },
        future: {
            fields: [
                'Open', 'High', 'Low', 'PClose', 'Upper Circuit', 'Lower Circuit', 'Volume', 'ATP',
                'OI', 'Change in OI', 'Lot Size', 'Roll Cost', 'Rollover', 'Spot Rate',
            ],
            mappings: {
                'Open': 'OpenRate',
                'High': 'High',
                'Low': 'Low',
                'PClose': 'PClose',
                'Volume': 'TotalQty',
                'ATP': 'AvgRate',
                'Spot Rate': 'SpotPrice',
                'OI': 'OpenInterest',
                'Change in OI': 'ChangeinOI',
                'Lot Size': 'Lotsize',
                'Rollover': { special: 'Rollover' },
                'RollCost': { special: 'RollCost' },
                'Upper Circuit': 'DPR',
                'Lower Circuit': 'DPR',
            },
        },
        option: {
            fields: [
                'Open', 'High', 'Low', 'PClose', 'Upper Circuit', 'Lower Circuit',
                'Volume', 'ATP', 'OI', 'Change in OI', 'Lot Size',
                'Roll Cost', 'Rollover', 'Spot Rate',
            ],
            mappings: {
                'Open': 'OpenRate',
                'High': 'High',
                'Low': 'Low',
                'PClose': 'PClose',
                'Volume': 'TotalQty',
                'ATP': 'AvgRate',
                'Spot Rate': 'SpotPrice',
                'OI': 'OpenInterest',
                'Change in OI': 'ChangeinOI',
                'Lot Size': 'Lotsize',
                'Upper Circuit': 'DPR',
                'Lower Circuit': 'DPR',
                'Rollover': { special: 'Rollover' },
                'Roll Cost': { special: 'RollCost' },
            },
        },
        cash: {
            fields: [
                'Open', 'High', 'Low', 'PClose', 'Upper Circuit',
                'Lower Circuit', 'Volume', 'ATP',
                'M-Capital(Cr)',
            ],
            mappings: {
                'Open': 'OpenRate',
                'High': 'High',
                'Low': 'Low',
                'PClose': 'PClose',
                'Volume': 'TotalQty',
                'ATP': 'AvgRate',
                'Upper Circuit': 'DPR',
                'Lower Circuit': 'DPR',
                'M-Capital(Cr)': 'MarketCapital',
            },
        },
        commodity_fut: {
            fields: [
                'Open', 'High', 'Low', 'PClose', 'Upper Circuit', 'Lower Circuit',
                'Volume', 'ATP', 'OI', 'Change in OI',
                'Lot Size', 'Roll Cost', 'Rollover', 'Spot Rate', 'Delivery Unit',
                'Quantity limit', 'Price Quote', 'Maturity',
                'Contract Start', 'Contract End', 'Tender Start',
                'Tender End', 'Delivery Start', 'Delivery End',
            ],
            mappings: {
                'Open': 'OpenRate',
                'High': 'High',
                'Low': 'Low',
                'PClose': 'PClose',
                'Volume': 'TotalQty',
                'ATP': 'AvgRate',
                'Spot Rate': 'SpotPrice',
                'OI': 'OpenInterest',
                'Change in OI': 'ChangeinOI',
                'Lot Size': 'Lotsize',
                'Upper Circuit': 'DPR',
                'Lower Circuit': 'DPR',
                'Delivery Unit': 'DeliveryUnit',
                'Price Quote': 'PriceQuotation',
                'Maturity': 'Maturity',
                'Contract Start': 'ContractStartDt',
                'Contract End': 'ContractEndDt',
                'Tender Start': 'TenderPrdStartDt',
                'Tender End': 'TenderPrdEndDt',
                'Delivery Start': 'DeliveryStartDt',
                'Delivery End': 'DeliveryEndDt',
                'Rollover': { special: 'Rollover' },
                'Roll Cost': { special: 'RollCost' },
                'Quantity limit': 'Quantity',
            },
        },
        commodity_opt: {
            fields: [
                'Open', 'High', 'Low', 'PClose', 'Upper Circuit', 'Lower Circuit',
                'Volume', 'ATP', 'OI', 'Change in OI',
                'Lot Size', 'Roll Cost', 'Rollover', 'Spot Rate', 'Delivery Unit',
                'Quantity limit', 'Price Quote', 'Maturity',
                'Contract Start', 'Contract End', 'Tender Start',
                'Tender End', 'Delivery Start', 'Delivery End',
            ],
            mappings: {
                'Open': 'OpenRate',
                'High': 'High',
                'Low': 'Low',
                'PClose': 'PClose',
                'Volume': 'TotalQty',
                'ATP': 'AvgRate',
                'Spot Rate': 'SpotPrice',
                'OI': 'OpenInterest',
                'Change in OI': 'ChangeinOI',
                'Lot Size': 'Lotsize',
                'Upper Circuit': 'DPR',
                'Lower Circuit': 'DPR',
                'Delivery Unit': 'DeliveryUnit',
                'Price Quote': 'PriceQuotation',
                'Maturity': 'Maturity',
                'Contract Start': 'ContractStartDt',
                'Contract End': 'ContractEndDt',
                'Tender Start': 'TenderPrdStartDt',
                'Tender End': 'TenderPrdEndDt',
                'Delivery Start': 'DeliveryStartDt',
                'Delivery End': 'DeliveryEndDt',
                'Rollover': { special: 'Rollover' },
                'Roll Cost': { special: 'RollCost' },
                'Quantity limit': 'Quantity',
            },
        },
    };
    const ulElement = document.querySelector('.orderListBody');
    if (!ulElement)
        return;
    ulElement.innerHTML = '';
    const config = stockTypeConfig[stockType.toLowerCase()];
    if (!config)
        return;
    const stockData = ((_h = (_g = apiData.body) === null || _g === void 0 ? void 0 : _g.Data) === null || _h === void 0 ? void 0 : _h[0]) || {};
    const updateProgressBar = (id, value) => {
        const element = document.getElementById(id);
        if (element && value !== 0 && value !== 'N.A') {
            element.textContent = intComma(value, 2);
        }
        else if (element) {
            element.textContent = '0.00';
        }
    };
    updateProgressBar('low52Week', stockData.Low52Week);
    updateProgressBar('high52Week', stockData.High52Week);
    updateProgressBar('lowToday', stockData.Low);
    updateProgressBar('highToday', stockData.High);
    const calcPercentage = (lastRate, low, high) => {
        if (high === low || !lastRate || !high || !low)
            return 0;
        const percentage = ((lastRate - low) / (high - low)) * 100;
        return Math.min(Math.max(percentage, 0), 100);
    };
    const weekPercentage = calcPercentage(stockData.LastRate, stockData.Low52Week, stockData.High52Week);
    const todayPercentage = calcPercentage(stockData.LastRate, stockData.Low, stockData.High);
    const updateProgressBarPointer = (selector, percentage) => {
        const pointer = document.querySelector(selector);
        if (pointer) {
            pointer.setAttribute('style', `left: ${percentage}%; transform: translateX(-50%)`);
        }
    };
    updateProgressBarPointer('#weekHighLowPointer', weekPercentage);
    updateProgressBarPointer('#todayHighLowPointer', todayPercentage);
    config.fields.forEach(field => {
        const mapping = config.mappings[field];
        let value = '-';
        if (mapping === null || mapping === void 0 ? void 0 : mapping.special) {
            value = specialValues[mapping.special];
        }
        else if (field === 'Upper Circuit' || field === 'Lower Circuit') {
            if (stockData.DPR) {
                const [lower, upper] = stockData.DPR.split(' - ');
                value = field === 'Upper Circuit' ? upper : lower;
                value = intComma(value, 2);
            }
        }
        else {
            const apiField = typeof mapping === 'string' ? mapping : field;
            value = stockData[apiField];
            switch (field) {
                case 'Open':
                case 'High':
                case 'Low':
                case 'PClose':
                case 'ATP':
                case 'Spot Rate':
                    value = intComma(value, 2);
                    break;
                case 'Volume':
                    value = convertNumberIntoLakhsAndCroreWithSign(value);
                    break;
                case 'OI':
                    value = convertNumberIntoLakhsAndCroreWithSign(value);
                    break;
                // case 'INT Exposure':
                // case 'DEL Exposure':
                //   value = formatExposure(value);
                //   break;
                case 'Change in OI':
                    const changeInOI = stockData.ChangeinOI;
                    const previousOI = stockData.PreviousOI;
                    if (changeInOI !== undefined && previousOI !== undefined && previousOI !== 0) {
                        const percentageChange = (changeInOI / previousOI) * 100;
                        value = percentageChange.toFixed(2) + '%';
                    }
                    else {
                        value = '0.00%';
                    }
                    break;
                case 'Lot Size':
                    value = intComma(value, 0);
                    break;
                case 'Maturity':
                    value = convertDateFormat(value, "DDMMMYYYY");
                    break;
                case 'Contract Start':
                case 'Contract End':
                case 'Tender Start':
                case 'Tender End':
                case 'Delivery Start':
                case 'Delivery End':
                    value = convertDateFormat(value);
                    break;
                default:
                    value = (value === null || value === void 0 ? void 0 : value.toString()) || '-';
            }
        }
        const li = document.createElement('li');
        li.className = '';
        li.id = `${stockType.toLowerCase()}-${field.toLowerCase().replace(/\s+/g, '-')}`;
        const div = document.createElement('div');
        div.className = 'orderListItem d-flex align-items-center justify-content-between';
        div.innerHTML = `
      <span>${field}</span>
      <span class="orderListBodyValue">${value}</span>
    `;
        li.appendChild(div);
        ulElement.appendChild(li);
    });
}
export function populateSymbolLtp(data, symbol) {
    var exCh = symbol.split(":")[0];
    var exChange = exCh.charAt(0);
    var exchType = symbol.split("-")[1];
    var scripCode = symbol.split("/")[1].split("-")[0];
    var token = parseInt(scripCode, 10);
    // Check if the single data object matches
    if (data.Token === token) {
        var price = data.LastRate.toFixed(2);
        var prevClose = data.PClose;
        var percentChange = (((data.LastRate - prevClose) / prevClose) * 100).toFixed(2) + '%';
        document.getElementById('stockPrice').textContent = price;
        var perChSymbolElement = document.getElementById('perChSymbol');
        perChSymbolElement.textContent = percentChange;
        if (parseFloat(percentChange) < 0) {
            perChSymbolElement.className = 'callPutPerc negativeText';
        }
        else {
            perChSymbolElement.className = 'callPutPerc positiveText';
        }
    }
    else {
        console.warn("Data does not match the provided symbol.");
    }
}
export const intiailiseIndiceList = async () => {
    try {
        const [niftyIndices, bankIndices] = await Promise.all([
            getIndicesList("N"),
            getIndicesList("B"),
        ]);
        niftyIndiceList = (niftyIndices.IndiceData || []).map((index) => index.IndiceID);
        bankIndiceList = (bankIndices.IndiceData || []).map((index) => index.IndiceID);
    }
    catch (error) {
        niftyIndiceList = [];
        bankIndiceList = [];
    }
};
export const checkScripIsIndex = async (scripCode) => {
    try {
        const scripCodeNum = Number(scripCode);
        if (niftyIndiceList.includes(scripCodeNum)) {
            return "nifty_index";
        }
        if (bankIndiceList.includes(scripCodeNum)) {
            return "bank_index";
        }
        return "";
    }
    catch (error) {
        console.error("Error checking if scrip is index:", error);
        return "";
    }
};
export const getStockType = async (symbol) => {
    if (!symbol)
        return '';
    const scripCodeParts = symbol.split("/");
    if (scripCodeParts.length > 1) {
        const scripCode = scripCodeParts[1].split("-")[0];
        if (scripCode) {
            const indexType = await checkScripIsIndex(scripCode);
            if (indexType !== "") {
                return indexType;
            }
        }
    }
    if (symbol.endsWith('-C')) {
        return 'cash';
    }
    const exchange = symbol.substring(0, 3);
    switch (exchange) {
        case 'MCX':
            return symbol.includes(' CE ') || symbol.includes(' PE ')
                ? 'commodity_opt'
                : 'commodity_fut';
        case 'NSE':
        case 'BSE':
            if (/\b(CE|PE)\b/.test(symbol)) {
                return 'option';
            }
            if (/\d{1,2} [A-Z]{3} \d{4}/.test(symbol)) {
                return 'future';
            }
            return '';
        default:
            return '';
    }
};
